import {FreeMode, Controller} from 'swiper';
import {Swiper, SwiperSlide as Slide} from 'swiper/react';
import '../index.css';
import {useRef} from "react";
import {useTranslation} from "react-i18next";

export default function TabsMall9(props) {
  const { t } = useTranslation();
  const swiperRef = useRef(null);
  let realWidth = 0;
  const {
    active,
    perview = 3,
    tabs,
    tabKey = null,
    onChange,
    fixed,
    style,
    tabsStyle,
    tabsActiveColor = '#333',
  } = props;
  
  const tabHandle = (active, i) => {
    onChange(active);
    
    if (!realWidth) {
      let swiperSlideEl = document.querySelectorAll('.swiper-slide');
      for (let i = 0; i < swiperSlideEl.length; i++) {
        realWidth += swiperSlideEl[i].offsetWidth;
      }
    }
    if (i === 1) {
      return swiperRef.current.swiper.translateTo(0);
    }
    
    if (i > tabs.length - 1) {
      return swiperRef.current.swiper.translateTo(realWidth);
    }
    
    swiperRef.current.swiper.slideTo(i);
  };
  
  return (
    <>
      <div className="md:mb-[20px] mdmax:hidden items-center
                    md:border-b-2 mdmax:bg-[#f4f4f6]"
           style={style}>
        {
          tabs.map((item, i) => {
            let label = tabKey && tabKey.label ? item[tabKey.label] : item.label;
            let value = tabKey && tabKey.value ? item[tabKey.value] : item.value;
            return (
              <a key={i}
                 onClick={() => tabHandle(value, i)}
                 style={tabsStyle}
                 className={'relative cursor-pointer inline-block py-[8px] text-center md:text-[15px] md:px-[26px] ' +
                 `${active === value ? 'md:text-[17px] font-bold text-[#ECBC40]' : ''}`}>
                {t(label)}
                {
                  active === value &&
                  <i className="h-[3px] w-[24px] inline-block absolute bottom-0 rounded-full left-[50%]" style={{ transform: 'translateX(-50%)', backgroundColor: tabsActiveColor }}/>
                }
              </a>
            );
          })
        }
      </div>
      <div className={`container ${fixed ? 'fixed' : ''} z-50`}>
        <Swiper
          ref={swiperRef}
          id="tabsSwiper"
          modules={[FreeMode]}
          className="bg-white md:hidden border-b border-[#eee]"
          slidesPerView={tabs.length > 4 ? 'auto' : tabs.length}>
          {
            tabs.map((item, i) => {
              let label = tabKey && tabKey.label ? item[tabKey.label] : item.label;
              let value = tabKey && tabKey.value ? item[tabKey.value] : item.value;
              return (
                <Slide style={{ padding: '0 20px', width: 'auto' }} key={i}>
                  <div onClick={() => tabHandle(value, i)}
                       className={'text-center text-[14px] py-[5px] ' +
                       'container text-[14px] __tabs mall9 ' +
                       `${active === value ? 'active text-[#ECBC40]' : ''}`}>
                    {t(label)}
                  </div>
                </Slide>
              );
            })
          }
        </Swiper>
      </div>
    </>
  );
}
